import React, {createContext, useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next';

import CONFIG from './app-config.json';
import SearchDefaults from './app-config-search';
import sessionData from './app-ctx-cookies';

const JOOMLA_VARS = Joomla.getOptions('com_kurortlife.options');

const ApplicationContext = createContext();

const ApplicationContextProvider = ({ children }) => {
    const { t } = useTranslation();

    const localizedSearchDefaults = useMemo(() => {
        const dietaryOptions = SearchDefaults.dietaryTreatmentSettings.dietaryOptions.map(option => ({
            ...option,
            label: t(option.label)
        }));

        return {
            ...SearchDefaults,
            dietaryTreatmentSettings: {
                ...SearchDefaults.dietaryTreatmentSettings,
                dietaryOptions
            }
        };
    }, [t]);

    console.log('ApplicationContextProvider().Entry sessionData=', JSON.stringify(sessionData));
    return (
      <ApplicationContext.Provider value={{ JOOMLA_VARS, CONFIG, 
                      SearchDefaults: localizedSearchDefaults, searchCriterias:sessionData.searchCriterias }}>
        {children}
      </ApplicationContext.Provider>
    );
};

const useAppCtx = () => {
    return useContext(ApplicationContext);
  };

export default ApplicationContextProvider;
export { useAppCtx }    ;